export default "/static/50d682d3b095542b.png"